import { BaseLayer } from "./BaseLayer";
import { HeatMapLayer } from "./HeatMapLayer";
import { DateTime } from "luxon";

export class IncidentsLayer extends BaseLayer {
  constructor(map, apiUrl, exportUrl, csrfToken) {
    super(map, apiUrl, exportUrl, csrfToken);
    this.toggleButton = document.getElementById("button-map-incidents");
    this.markerTitle = "Incident";
    this.layerName = "IncidentsLayer";
    this.exportName = "Incidents";
    this.create();
    this.heatmap = new HeatMapLayer(this.map, this.layer, this);
  }

  showInfoWindow(event) {
    const postalCode = event.feature.getProperty("post_code");
    const zip = postalCode === "Unknown" ? "" : postalCode;

    let incidentsAtSameCoords = [];
    const feature = event.feature;

    // Check only those who share the location with another incident
    if (feature.getProperty("at_same_location_count") > 1) {
      incidentsAtSameCoords = feature.getProperty("ids_of_collection_at_same_location");
    }

    // Sort the found incidents by date (newest date at top)
    incidentsAtSameCoords.sort(function (a, b) {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      return dateA > dateB ? -1 : a < b ? 1 : 0;
    });

    let listItems;
    if (incidentsAtSameCoords.length > 1) {
      listItems = incidentsAtSameCoords.map((incident) => {
        const date = DateTime.fromSeconds(incident.date);
        return (
          '<a href="#" title="Show details for this incident" class="markerPopupButton" data-toggle="modal" data-target="#detailModal" data-key="' +
          incident.id +
          '" data-href="/incident/view?id=' +
          incident.id +
          '" data-incident-id="' +
          incident.id +
          '">' +
          incident.category +
          " - " +
          date.toFormat("dd/LL/yyyy") +
          "</a>"
        );
      });
      this.createInfoWindow(listItems, event, false);
    } else {
      const date = DateTime.fromSeconds(event.feature.getProperty("date_incident"));
      listItems = [
        '<i class="fa-li fa fa-calendar-alt"></i> Date: ' + date.toFormat("dd/LL/yyyy"),
        '<i class="fa-li fa fa-truck"></i> Modus Operandi: ' + event.feature.getProperty("modus_operandi"),
        '<i class="fa-li fa fa-gem"></i> Product category: ' + event.feature.getProperty("product_category"),
        '<i class="fa-li fa fa-globe-europe"></i> Site of crime: ' + event.feature.getProperty("site_of_crime"),
        '<i class="fa-li fa fa-search-location"></i> Location type: ' + event.feature.getProperty("location_type"),
        '<i class="fa-li fa fa-map-marker-alt"></i> Town: ' + zip + " " + event.feature.getProperty("town"),
      ];
      this.createInfoWindow(listItems, event);
    }
  }
}
